import { useState } from "react";
import React from "react";
import InputType from "./InputType";
import { Link } from "react-router-dom";
import { handleLogin, handleRegister } from "../../../services/authService";
const Form = ({ submitBtn, formTitle, formType }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("donar");
  const [name, setName] = useState("");
  const [organisationName, setOrganisationName] = useState("");
  const [website, setWebsite] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [hospitalName, setHospitalName] = useState("");

  const handleRoleChange = (e) => {
    setRole(e.target.value);
  };

  return (
    <div>
      <form
        onSubmit={(e) => {
          if (formType === "login")
            return handleLogin(e, email, password, role);
          else if (formType === "register")
            return handleRegister(
              e,
              name,
              role,
              email,
              password,
              phone,
              organisationName,
              address,
              hospitalName,
              website
            );
        }}
      >
        <h1 className="text-center">{formTitle}</h1>
        <hr />
        <div className="d-flex flex-column mb-3">
          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              name="role"
              id="donarRadio"
              value="donar"
              onChange={handleRoleChange}
              defaultChecked
            />
            <label htmlFor="donarRadio" className="form-check-label">
              Donor
            </label>
          </div>
          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              name="role"
              id="adminRadio"
              value="admin"
              onChange={handleRoleChange}
            />
            <label htmlFor="adminRadio" className="form-check-label">
              Admin
            </label>
          </div>
          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              name="role"
              id="hospitalRadio"
              value="hospital"
              onChange={handleRoleChange}
            />
            <label htmlFor="hospitalRadio" className="form-check-label">
              Hospital
            </label>
          </div>
          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              name="role"
              id="organisationRadio"
              value="organisation"
              onChange={handleRoleChange}
            />
            <label htmlFor="organisationRadio" className="form-check-label">
              Organisation
            </label>
          </div>
        </div>
        {/* switch statement */}
        {(() => {
          //eslint-disable-next-line
          switch (true) {
            case formType === "login": {
              return (
                <>
                  <InputType
                    labelText={"Email"}
                    labelFor={"foremail"}
                    inputType={"email"}
                    name={"email"}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <InputType
                    labelText={"Password"}
                    labelFor={"forpassword"}
                    inputType={"password"}
                    name={"password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </>
              );
            }
            case formType === "register": {
              return (
                <>
                  {(role === "admin" || role === "donar") && (
                    <InputType
                      labelText={"Name"}
                      labelFor={"forName"}
                      inputType={"text"}
                      name={"name"}
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  )}
                  {role === "organisation" && (
                    <InputType
                      labelText={"Organisation Name"}
                      labelFor={"forOrganisationName"}
                      inputType={"text"}
                      name={"organisationName"}
                      value={organisationName}
                      onChange={(e) => setOrganisationName(e.target.value)}
                    />
                  )}
                  {role === "hospital" && (
                    <InputType
                      labelText={"Hospital Name"}
                      labelFor={"forHospitalName"}
                      inputType={"text"}
                      name={"hospitalName"}
                      value={hospitalName}
                      onChange={(e) => setHospitalName(e.target.value)}
                    />
                  )}
                  <InputType
                    labelText={"Email"}
                    labelFor={"foremail"}
                    inputType={"email"}
                    name={"email"}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <InputType
                    labelText={"Password"}
                    labelFor={"forpassword"}
                    inputType={"password"}
                    name={"password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <InputType
                    labelText={"Website"}
                    labelFor={"forWebsite"}
                    inputType={"text"}
                    name={"website"}
                    value={website}
                    onChange={(e) => setWebsite(e.target.value)}
                  />
                  <InputType
                    labelText={"Address"}
                    labelFor={"forAddress"}
                    inputType={"text"}
                    name={"address"}
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                  <InputType
                    labelText={"Phone"}
                    labelFor={"forPhone"}
                    inputType={"text"}
                    name={"phone"}
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </>
              );
            }
          }
        })()}

        <div className="d-flex  flex-row justify-content-between">
          {formType === "login" ? (
            <p>
              Not Registered Yet ? <Link to="/register">Here !</Link>
            </p>
          ) : (
            <p>
              Already Registered ? <Link to="/login">Login</Link>
            </p>
          )}
          <br />
          <button className="btn btn-primary ms-4">{submitBtn}</button>
        </div>
      </form>
    </div>
  );
};

export default Form;

// import { useState } from "react";
// import React from "react";
// import InputType from "./InputType";

// const Form = ({ submitBtn, formTitle, formType }) => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [role, setRole] = useState("donar");
//   const [name, setName] = useState("");
//   const [organisationName, setorganisationName] = useState("");
//   const [website, setWebiste] = useState("");
//   const [address, setAddress] = useState("");
//   const [phone, setPhone] = useState("");
//   const [hospitalName, setHospitalName] = useState("");
//   return (
//     <div>
//       <form>
//         <h1 className="text-center">{formTitle}</h1>
//         <hr />
//         <div className="d-flex mb-3">
//           <div className="form-check">
//             <input
//               type="radio"
//               className="form-check-input"
//               name="role"
//               id="donarRadio"
//               value={"donar"}
//               onChange={(e) => setRole(e.target.value)}
//               defaultChecked
//             />
//             <label htmlFor="adminRadio" className="form-check-label">
//               Donar
//             </label>
//           </div>
//           <div className="form-check ms-2">
//             <input
//               type="radio"
//               className="form-check-input"
//               name="role"
//               id="adminRadio"
//               value={"admin"}
//               onChange={(e) => setRole(e.target.value)}
//             />
//             <label htmlFor="adminRadio" className="form-check-label">
//               Admin
//             </label>
//           </div>
//           <div className="form-check ms-2">
//             <input
//               type="radio"
//               className="form-check-input"
//               name="role"
//               id="hospitalRadio"
//               value={"hospital"}
//               onChange={(e) => setRole(e.target.value)}
//             />
//             <label htmlFor="hospitalRadio" className="form-check-label">
//               Hospital
//             </label>
//           </div>
//           <div className="form-check ms-2">
//             <input
//               type="radio"
//               className="form-check-input"
//               name="role"
//               id="organisationRadio"
//               value={"organisation"}
//               onChange={(e) => setRole(e.target.value)}
//             />
//             <label htmlFor="organisationRadio" className="form-check-label">
//               Organisation
//             </label>
//           </div>
//         </div>
//         {/* switch statement */}
//         {(() => {
//           //eslint-disable-next-line
//           switch (true) {
//             case formType === "login": {
//               return (
//                 <>
//                   <InputType
//                     labelText={"Email"}
//                     labelFor={"foremail"}
//                     inputType={"email"}
//                     name={"email"}
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)} // e.target.value is the value of the input field
//                   />{" "}
//                   <InputType
//                     labelText={"Password"}
//                     labelFor={"forpassword"}
//                     inputType={"password"}
//                     name={"password"}
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)} // e.target.value is the value of the input field
//                   />
//                 </>
//               );
//             }
//             case formType === "register": {
//               return (
//                 <>
//                   {(role === "admin" || role === "donar") && (
//                     <InputType
//                       labelText={"Name"}
//                       labelFor={"forName"}
//                       inputType={"text"}
//                       name={"name"}
//                       value={name}
//                       onChange={(e) => setName(e.target.value)} // e.target.value is the value of the input field
//                     />
//                   )}
//                   {role === "organisation" && (
//                     <InputType
//                       labelText={"Organisation Name"}
//                       labelFor={"fororganisationName"}
//                       inputType={"text"}
//                       name={"organisationName"}
//                       value={organisationName}
//                       onChange={(e) => setorganisationName(e.target.value)} // e.target.value is the value of the input field
//                     />
//                   )}
//                   {role === "hospital" && (
//                     <InputType
//                       labelText={"Hospital Name"}
//                       labelFor={"forHospitalName"}
//                       inputType={"text"}
//                       name={"hospitalName"}
//                       value={hospitalName}
//                       onChange={(e) => setHospitalName(e.target.value)} // e.target.value is the value of the input field
//                     />
//                   )}
//                   <InputType
//                     labelText={"Email"}
//                     labelFor={"foremail"}
//                     inputType={"email"}
//                     name={"email"}
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)} // e.target.value is the value of the input field
//                   />{" "}
//                   <InputType
//                     labelText={"Password"}
//                     labelFor={"forpassword"}
//                     inputType={"password"}
//                     name={"password"}
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)} // e.target.value is the value of the input field
//                   />
//                   <InputType
//                     labelText={"Website"}
//                     labelFor={"forWebiste"}
//                     inputType={"text"}
//                     name={"website"}
//                     value={website}
//                     onChange={(e) => setWebiste(e.target.value)} // e.target.value is the value of the input field
//                   />
//                   <InputType
//                     labelText={"Address"}
//                     labelFor={"forAddress"}
//                     inputType={"text"}
//                     name={"address"}
//                     value={address}
//                     onChange={(e) => setAddress(e.target.value)} // e.target.value is the value of the input field
//                   />
//                   <InputType
//                     labelText={"Phone"}
//                     labelFor={"forPhone"}
//                     inputType={"text"}
//                     name={"phone"}
//                     value={phone}
//                     onChange={(e) => setPhone(e.target.value)} // e.target.value is the value of the input field
//                   />
//                 </>
//               );
//             }
//           }
//         })()}

//         <div className="d-flex">
//           <button className="btn btn-primary">{submitBtn}</button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default Form;
